export const getPromoName = () => {
  const date = new Date();
  if (date.getMonth() < 7) return 'Only The First';
  return 'Special Price';
};